import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo1.svg";
import ResetPasswordOTPComponent from "../../components/auth/ResetPasswordOTP";

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ResetPasswordOTP() {
  return (
    <React.Fragment>
      <Brand />
      <Wrapper>
        <Helmet title="Reset Password" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Redefinir Senha
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Preencha os campos abaixo para redefinir sua senha
        </Typography>

        <ResetPasswordOTPComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetPasswordOTP;
